/* irh-core.js: shared engine for the iSpice recipe hub (2026-10-13).
   Loaded by the hub (blogs), the recipe page (articles) and the share page. Exposes window.IRH.
   Nothing here touches the page by itself: it loads the recipe feed, turns raw Shopify tags into
   real categories, reads the messy prep/cook text, searches, and draws a recipe card. */
(function () {
  'use strict';
  if (window.IRH) return;

  /* ---------------- small helpers ---------------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/&/g, ' and ').replace(/[^a-z0-9½¼¾⅓⅔ ]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function words(s) { var n = norm(s); return n ? n.split(' ') : []; }
  function store(k, v) {
    try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null'); localStorage.setItem(k, JSON.stringify(v)); }
    catch (e) { return null; }
  }

  /* ---------------- icons (stroke, inherit colour) ---------------- */
  var I = {
    search: '<path d="M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM20 20l-4-4"/>',
    clock: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>',
    heart: '<path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/>',
    x: '<path d="M6 6l12 12M18 6L6 18"/>',
    bolt: '<path d="M13 3L5 13.5h6L10 21l8-10.5h-6z"/>',
    globe: '<circle cx="12" cy="12" r="8.5"/><path d="M3.5 12h17M12 3.5c2.5 2.6 3.6 5.5 3.6 8.5s-1.1 5.9-3.6 8.5c-2.5-2.6-3.6-5.5-3.6-8.5S9.5 6.1 12 3.5z"/>',
    pot: '<path d="M4 10h16v3a7 7 0 0 1-7 7h-2a7 7 0 0 1-7-7zM2 10h20M9 6.5c0-1 1-1.5 1-2.5M13 6.5c0-1 1-1.5 1-2.5"/>',
    jar: '<path d="M8 3h8v3H8zM7 6h10l1 3v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V9z"/><path d="M6 12h12"/>',
    dice: '<rect x="4" y="4" width="16" height="16" rx="4"/><circle cx="9" cy="9" r="1.2" fill="currentColor"/><circle cx="15" cy="15" r="1.2" fill="currentColor"/><circle cx="15" cy="9" r="1.2" fill="currentColor"/><circle cx="9" cy="15" r="1.2" fill="currentColor"/>',
    cart: '<path d="M3 4h2.5l2.2 10.5h10l2-7.5H7"/><circle cx="9.5" cy="19" r="1.4"/><circle cx="17" cy="19" r="1.4"/>',
    print: '<path d="M7 9V4h10v5M7 17H5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2M7 14h10v6H7z"/>',
    share: '<path d="M12 3v12M7 8l5-5 5 5M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6"/>',
    play: '<path d="M8 5l11 7-11 7z"/>',
    chef: '<path d="M7 14.5V20h10v-5.5M7 14.5a4 4 0 0 1-1-7.8A4.5 4.5 0 0 1 12 4a4.5 4.5 0 0 1 6 2.7 4 4 0 0 1-1 7.8z"/>',
    timer: '<circle cx="12" cy="13" r="7.5"/><path d="M12 9.5V13l2.2 1.4M10 2.5h4"/>',
    list: '<path d="M9 6h11M9 12h11M9 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01"/>',
    upload: '<path d="M12 16V4M7 9l5-5 5 5M4 16v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3"/>',
    gift: '<rect x="3.5" y="8" width="17" height="4" rx="1"/><path d="M5 12v8h14v-8M12 8v12M12 8c-1.5-3.5-5-3.5-5-1.2C7 8 12 8 12 8zM12 8c1.5-3.5 5-3.5 5-1.2C17 8 12 8 12 8z"/>',
    filter: '<path d="M4 6h16M7 12h10M10 18h4"/>'
  };
  function icon(name, cls) { return '<svg class="irh-ico' + (cls ? ' ' + cls : '') + '" viewBox="0 0 24 24" aria-hidden="true">' + (I[name] || '') + '</svg>'; }

  /* ---------------- taxonomy: raw Shopify tags -> real categories ----------------
     [key, label, tags that mean it]. Tags are compared lower-cased. */
  var MEAL = [
    ['breakfast', 'Breakfast & brunch', ['breakfast & brunch', 'breakfast', 'brunch']],
    ['starters', 'Starters & dips', ['appetizers', 'dip']],
    ['mains', 'Main dishes', ['maindish']],
    ['soups', 'Soups', ['soups', 'soup']],
    ['stews', 'Stews & braises', ['stews', 'stew']],
    ['salads', 'Salads', ['salads']],
    ['handheld', 'Sandwiches & tacos', ['sandwich', 'tacos']],
    ['grill', 'Grill & kebabs', ['kebab']],
    ['sides', 'Sides', ['sidedishes']],
    ['bakes', 'Breads & bakes', ['bread']],
    ['desserts', 'Desserts', ['desserts']],
    ['drinks', 'Drinks', ['drinks']]
  ];
  /* region: am Americas, eu Europe, me Middle East & Africa, as Asia & Pacific */
  var CUI = [
    ['american', 'American', ['american'], 'am'], ['southwest', 'Southwestern', ['southwest'], 'am'],
    ['mexican', 'Mexican', ['mexican'], 'am'], ['latin', 'Latin American', ['latin'], 'am'],
    ['cuban', 'Cuban', ['cuban'], 'am'], ['jamaican', 'Jamaican', ['jamaican'], 'am'],
    ['brazilian', 'Brazilian', ['brazilian'], 'am'], ['argentinian', 'Argentinian', ['argentinian'], 'am'],
    ['italian', 'Italian', ['italian'], 'eu'], ['french', 'French', ['french'], 'eu'],
    ['spanish', 'Spanish', ['spanish'], 'eu'], ['greek', 'Greek', ['greek'], 'eu'],
    ['mediterranean', 'Mediterranean', ['mediterranean'], 'eu'], ['german', 'German', ['german'], 'eu'],
    ['irish', 'Irish', ['irish'], 'eu'], ['hungarian', 'Hungarian', ['hungarian'], 'eu'], ['russian', 'Russian', ['russian'], 'eu'],
    ['middleeastern', 'Middle Eastern', ['middleeastern'], 'me'], ['lebanese', 'Lebanese', ['lebanese'], 'me'],
    ['persian', 'Persian', ['persian'], 'me'], ['turkish', 'Turkish', ['turkish'], 'me'],
    ['moroccan', 'Moroccan', ['moroccan'], 'me'], ['egyptian', 'Egyptian', ['egyptian'], 'me'], ['african', 'African', ['african'], 'me'],
    ['indian', 'Indian', ['indian'], 'as'], ['chinese', 'Chinese', ['chinese'], 'as'], ['japanese', 'Japanese', ['japanese'], 'as'],
    ['korean', 'Korean', ['korean'], 'as'], ['thai', 'Thai', ['thai'], 'as'], ['vietnamese', 'Vietnamese', ['vietnamese'], 'as'],
    ['filipino', 'Filipino', ['filipino'], 'as'], ['indonesian', 'Indonesian', ['indonesian'], 'as'],
    ['malaysian', 'Malaysian', ['malaysian'], 'as'], ['asian', 'Pan-Asian', ['asian'], 'as']
  ];
  var REGIONS = [['all', 'All'], ['am', 'The Americas'], ['eu', 'Europe'], ['me', 'Middle East & Africa'], ['as', 'Asia']];
  var MAIN = [
    ['chicken', 'Chicken & poultry', ['chicken', 'poultry'], /\b(chicken|turkey|duck|poultry)\b/],
    ['beef', 'Beef', ['beef'], /\b(beef|steak|brisket|veal|burger|meatball|meatloaf|bavette|filet mignon)\b/],
    ['lamb', 'Lamb', ['lamb'], /\blamb\b/],
    ['pork', 'Pork & sausage', ['pork', 'sausage'], /\b(pork|bacon|ham|sausage|chorizo)\b/],
    ['seafood', 'Fish & seafood', ['fish', 'seafood'], /\b(fish|salmon|tuna|cod|shrimp|prawn|seafood|crab|tilapia|mussel|scallop)\b/],
    ['eggs', 'Eggs', ['eggs'], /\b(egg|eggs|omelette|omelet|frittata|shakshouka|quiche)\b/],
    ['legumes', 'Beans & lentils', ['beans', 'lentils'], /\b(bean|beans|lentil|lentils|chickpea|chickpeas|hummus|falafel|dal)\b/],
    ['tofu', 'Tofu', ['tofu'], /\btofu\b/],
    ['veg', 'Vegetables', ['vegetables'], /\b(vegetable|veggie|eggplant|cauliflower|zucchini|spinach|mushroom|squash)\b/],
    ['potato', 'Potatoes', ['potato'], /\b(potato|potatoes)\b/],
    ['rice', 'Rice', ['rice'], /\b(rice|risotto|paella|biryani|pilaf)\b/],
    ['pasta', 'Pasta & noodles', ['pastanoodle'], /\b(pasta|noodle|noodles|spaghetti|lasagna|ramen|penne|macaroni)\b/],
    ['dairy', 'Cheese & dairy', ['cheese', 'dairy'], null],
    ['grains', 'Grains & flour', ['grainsseeds', 'flour'], null],
    ['nuts', 'Nuts', ['nuts'], null],
    ['fruit', 'Fruit', ['fruits'], null]
  ];
  var LIFE = [
    ['light', 'Lighter', ['healthy']],
    ['lowcarb', 'Low-carb', ['lowcarb']],
    ['winter', 'Winter warmers', ['winter cooking', 'winter recipes', 'warming spices']],
    ['video', 'With video', []]
  ];
  var TIME = [['15', '15 min or less'], ['30', '30 min or less'], ['60', 'Up to 1 hour'], ['slow', 'Slow-cooked (3 h+)']];
  var GROUPS = { meal: MEAL, cui: CUI, main: MAIN, life: LIFE };
  function labelOf(group, key) {
    if (group === 'time') { for (var i = 0; i < TIME.length; i++) if (TIME[i][0] === key) return TIME[i][1]; return key + ' min or less'; }
    var g = GROUPS[group] || []; for (var j = 0; j < g.length; j++) if (g[j][0] === key) return g[j][1]; return key;
  }

  /* ---------------- time: "10 minutes", "1 hour", "20", "4 hours " -> minutes ---------------- */
  function mins(s) {
    if (s == null) return null;
    s = String(s).toLowerCase().replace(/½/g, '.5').trim();
    if (!s) return null;
    if (/^\d+\s*-\s*\d+$/.test(s)) return null;          /* "2-3": no unit, can't tell hours from minutes */
    var h = s.match(/(\d+(?:\.\d+)?)\s*(?:h|hr|hrs|hour|hours)\b/), m = s.match(/(\d+(?:\.\d+)?)\s*(?:m|min|mins|minute|minutes)\b/);
    if (h || m) return Math.round((h ? parseFloat(h[1]) * 60 : 0) + (m ? parseFloat(m[1]) : 0));
    var n = parseFloat(s); return isNaN(n) ? null : Math.round(n);   /* a bare number is minutes */
  }
  function fmt(m) {
    if (m == null) return '';
    if (m < 60) return m + ' min';
    var h = Math.floor(m / 60), r = m % 60;
    return h + ' h' + (r ? ' ' + r + ' min' : '');
  }

  /* ---------------- ingredient lines ---------------- */
  var STAPLE = /^(salt|kosher salt|sea salt|black pepper|pepper|salt and pepper|salt and black pepper|water|ice|oil|olive oil|extra virgin olive oil|vegetable oil|canola oil|cooking spray|butter|sugar|all purpose flour|flour)$/;
  function cleanName(line) {
    return norm(String(line)
      .replace(/\(.*?\)/g, ' ')
      .replace(/\b(boneless|skinless|bone-in|skin-on)\b,?/gi, ' ')
      .replace(/^[\s\d½¼¾⅓⅔\/.,-]+/, ' ')
      .replace(/\b(cups?|tbsps?|tablespoons?|tsps?|teaspoons?|lbs?|pounds?|oz|ounces?|grams?|g|kg|ml|l|liters?|litres?|cloves?|cans?|pinch|dash|handful|bunch|slices?|pieces?|sprigs?|small|medium|large|whole|fresh|freshly|dried|ground|chopped|diced|minced|sliced|grated|finely|roughly|thinly|to taste|optional|for serving|for garnish|packed|about|plus more|divided|of)\b/gi, ' ')
      .split(/,| or | for /)[0]);
  }
  function isHeader(line) { return /:\s*$/.test(line) && line.length < 60; }
  /* "iSpice Chicken Seasoning" is a spice, not chicken: the kitchen matcher skips these lines */
  var SPICE_LINE = /\b(ispice|seasoning|seasonings|spice|spices|blend|rub|masala|powder)\b/;
  /* "boneless skinless chicken thighs" -> "chicken thighs", "zest and juice of 1 lemon" -> "lemon" */
  var FILLER = /\b(boneless|skinless|zest|juice|and|cooked|uncooked|shredded|peeled|seeded|crushed|softened|melted|room temperature|cold|warm|hot|thick|thin|cut|into|pieces|cubes|cubed|halved|quartered|trimmed|rinsed|drained|beaten|packed|extra|virgin|low|sodium|reduced|fat|free|plain|unsalted|salted|boiling|\d+)\b/g;
  function shortName(n) {
    var w = String(n || '').replace(FILLER, ' ').replace(/\s+/g, ' ').trim().split(' ').filter(Boolean);
    return (w.length > 2 ? w.slice(-2) : w).join(' ') || String(n || '').split(' ').slice(0, 2).join(' ');
  }
  /* "iSpice | Salt-Free Seafood Seasoning | 4.76 oz | Mixed Spice..." -> "Salt-Free Seafood Seasoning" */
  function shortTitle(t) {
    var p = String(t || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean);
    if (p.length > 1 && /^ispice$/i.test(p[0])) return p[1];
    return p[0] || '';
  }
  /* the newer recipes: pull the ingredient lines out of the article text (¦ marks line ends) */
  function linesFromBody(b) {
    if (!b) return [];
    var parts = String(b).split('¦').map(function (x) { return x.replace(/\s+/g, ' ').trim(); }).filter(Boolean);
    var out = [], on = false;
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i], low = p.toLowerCase();
      if (!on) { if (/^ingredients?\b/.test(low) && p.length < 40) on = true; continue; }
      if (/^(instructions?|directions?|method|steps?|preparation|how to (make|cook)|to make|notes?|tips?)\b/.test(low) && p.length < 50) break;
      if (p.length > 160) break;   /* a paragraph: the list is over */
      out.push(p);
    }
    return out.slice(0, 40);
  }

  /* ---------------- one recipe, ready to use ---------------- */
  var CACHE_KEY = 'irh-feed-v2', TTL = 6 * 3600 * 1000;
  function prep(raw) {
    var tags = (raw.g || []).map(function (t) { return String(t).toLowerCase(); });
    function pick(list) { return list.filter(function (e) { return e[2].some(function (t) { return tags.indexOf(t) > -1; }); }).map(function (e) { return e[0]; }); }
    var r = {
      h: raw.h, t: raw.t || '', u: raw.u, i: raw.i || null, tags: tags,
      meal: pick(MEAL), cui: pick(CUI), main: pick(MAIN), life: pick(LIFE),
      prep: mins(raw.p), cook: mins(raw.c), serv: raw.s ? String(raw.s).trim() : '',
      kcal: raw.k ? parseInt(raw.k, 10) || null : null, video: !!raw.v,
      lines: (raw.n && raw.n.length ? raw.n : linesFromBody(raw.b)).map(function (l) { return String(l).replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim(); }).filter(Boolean),
      body: raw.b ? String(raw.b).replace(/¦/g, ' ') : '',
      x: (raw.x || []).filter(function (p) { return p && p.h; })
    };
    if (r.video) r.life.push('video');
    /* untagged recipes: take the main ingredient from the title only (safe, never guessed from the body) */
    if (!r.main.length) {
      var tn = norm(r.t);
      MAIN.forEach(function (e) { if (e[3] && e[3].test(tn)) r.main.push(e[0]); });
    }
    r.total = r.cook != null ? (r.prep || 0) + r.cook : null;
    r.ing = r.lines.filter(function (l) { return !isHeader(l); });
    r.names = r.ing.map(cleanName);
    /* search fields */
    var lab = [].concat(
      r.meal.map(function (k) { return labelOf('meal', k); }), r.cui.map(function (k) { return labelOf('cui', k); }),
      r.main.map(function (k) { return labelOf('main', k); }), r.life.map(function (k) { return labelOf('life', k); }), tags);
    r._t = words(r.t); r._g = words(lab.join(' ')); r._n = words(r.ing.join(' '));
    r._x = words(r.x.map(function (p) { return p.t; }).join(' ')); r._b = r.lines.length ? [] : words(r.body).slice(0, 400);
    return r;
  }

  /* ---------------- the feed ---------------- */
  var loading = null;
  function feedUrl(base, page) {
    var pv = (location.search.match(/preview_theme_id=(\d+)/) || [])[1];
    return base + '?view=isx-data&page=' + page + (pv ? '&preview_theme_id=' + pv : '');
  }
  function load(base) {
    if (loading) return loading;
    base = base || '/blogs/all-new-recipes';
    var cached = store(CACHE_KEY);
    if (cached && cached.base === base && Date.now() - cached.at < TTL && cached.items && cached.items.length) {
      loading = Promise.resolve(cached.items.map(prep));
      /* refresh quietly in the background so a new recipe appears on the next page view */
      setTimeout(function () { fetchAll(base).then(function (items) { store(CACHE_KEY, { base: base, at: Date.now(), items: items }); }).catch(function () {}); }, 4000);
      return loading;
    }
    loading = fetchAll(base).then(function (items) {
      store(CACHE_KEY, { base: base, at: Date.now(), items: items });
      return items.map(prep);
    });
    loading.catch(function () { loading = null; });
    return loading;
  }
  function getJSON(u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('feed ' + r.status); return r.json(); }); }
  function fetchAll(base) {
    return getJSON(feedUrl(base, 1)).then(function (first) {
      var rest = [];
      for (var p = 2; p <= (first.pages || 1); p++) rest.push(getJSON(feedUrl(base, p)));
      return Promise.all(rest).then(function (pages) {
        var all = first.items || [];
        pages.forEach(function (pg) { all = all.concat(pg.items || []); });
        /* a recipe published twice (same title) is shown once */
        var seen = {};
        return all.filter(function (r) { var k = norm(r.t); if (seen[k]) return false; seen[k] = 1; return true; });
      });
    });
  }

  /* ---------------- search ---------------- */
  var STOP = { a: 1, an: 1, and: 1, the: 1, of: 1, with: 1, in: 1, for: 1, to: 1, recipe: 1, recipes: 1, how: 1, make: 1, my: 1, some: 1, best: 1, dish: 1, dishes: 1, food: 1, i: 1, want: 1, me: 1, something: 1, idea: 1, ideas: 1 };
  var SYN = {
    shrimp: ['prawn'], prawn: ['shrimp'], cilantro: ['coriander'], coriander: ['cilantro'], aubergine: ['eggplant'], eggplant: ['aubergine'],
    courgette: ['zucchini'], zucchini: ['courgette'], garbanzo: ['chickpea'], chickpea: ['garbanzo'], chili: ['chile', 'chilli'], chilli: ['chili', 'chile'],
    kebab: ['kabob', 'kebob', 'skewer'], kabob: ['kebab'], noodle: ['pasta'], bbq: ['grill', 'grilled', 'barbecue'], barbecue: ['bbq', 'grill'],
    yoghurt: ['yogurt'], yogurt: ['yoghurt'], scallion: ['green onion'], capsicum: ['bell pepper'], mince: ['ground']
  };
  /* words that mean a category: become a filter chip instead of plain text */
  var ALIAS = { cui: {}, meal: {} };
  CUI.forEach(function (e) { ALIAS.cui[e[0]] = e[0]; ALIAS.cui[norm(e[1])] = e[0]; });
  [['mexico', 'mexican'], ['italy', 'italian'], ['france', 'french'], ['spain', 'spanish'], ['greece', 'greek'], ['germany', 'german'], ['ireland', 'irish'],
   ['hungary', 'hungarian'], ['russia', 'russian'], ['lebanon', 'lebanese'], ['iran', 'persian'], ['persia', 'persian'], ['morocco', 'moroccan'],
   ['egypt', 'egyptian'], ['africa', 'african'], ['india', 'indian'], ['china', 'chinese'], ['japan', 'japanese'], ['korea', 'korean'],
   ['thailand', 'thai'], ['vietnam', 'vietnamese'], ['philippines', 'filipino'], ['indonesia', 'indonesian'], ['malaysia', 'malaysian'],
   ['cuba', 'cuban'], ['jamaica', 'jamaican'], ['brazil', 'brazilian'], ['argentina', 'argentinian'], ['tex mex', 'southwest'],
   ['middle east', 'middleeastern'], ['asia', 'asian'], ['latin', 'latin'], ['america', 'american'], ['usa', 'american']]
    .forEach(function (p) { ALIAS.cui[p[0]] = p[1]; });
  [['breakfast', 'breakfast'], ['brunch', 'breakfast'], ['starter', 'starters'], ['starters', 'starters'], ['appetizer', 'starters'], ['appetizers', 'starters'],
   ['dip', 'starters'], ['dips', 'starters'], ['snack', 'starters'], ['snacks', 'starters'], ['dinner', 'mains'], ['main', 'mains'], ['mains', 'mains'],
   ['soup', 'soups'], ['soups', 'soups'], ['stew', 'stews'], ['stews', 'stews'], ['braise', 'stews'], ['salad', 'salads'], ['salads', 'salads'],
   ['sandwich', 'handheld'], ['sandwiches', 'handheld'], ['taco', 'handheld'], ['tacos', 'handheld'], ['wrap', 'handheld'], ['grill', 'grill'],
   ['grilled', 'grill'], ['kebab', 'grill'], ['kebabs', 'grill'], ['skewers', 'grill'], ['side', 'sides'], ['sides', 'sides'], ['bread', 'bakes'],
   ['dessert', 'desserts'], ['desserts', 'desserts'], ['sweet', 'desserts'], ['drink', 'drinks'], ['drinks', 'drinks']]
    .forEach(function (p) { ALIAS.meal[p[0]] = p[1]; });

  /* "quick italian dinner under 20 min" -> {time:20, cui:[italian], meal:[mains], text:''} */
  function understand(q) {
    var s = ' ' + norm(q) + ' ', out = { time: null, cui: [], meal: [], text: '' };
    var m = s.match(/\b(?:under|less than|within|in|max|up to)\s*(\d{1,3})\s*(?:m|min|mins|minutes?)?\b/) || s.match(/\b(\d{1,3})\s*(?:m|min|mins|minutes)\b/);
    if (m) { out.time = Math.max(5, parseInt(m[1], 10)); s = s.replace(m[0], ' '); }
    if (/\b(quick|fast|speedy|express|weeknight|in a hurry|easy)\b/.test(s)) { out.time = out.time || 30; s = s.replace(/\b(quick|fast|speedy|express|weeknight|in a hurry|easy)\b/g, ' '); }
    /* two-word names first */
    ['middle eastern', 'middle east', 'tex mex', 'latin american'].forEach(function (ph) {
      if (s.indexOf(' ' + ph + ' ') > -1) { var k = ALIAS.cui[ph] || ALIAS.cui[norm(ph)]; if (k) { out.cui.push(k); s = s.replace(' ' + ph + ' ', ' '); } }
    });
    var rest = [];
    s.trim().split(' ').forEach(function (w) {
      if (!w) return;
      if (ALIAS.cui[w] && out.cui.indexOf(ALIAS.cui[w]) < 0) { out.cui.push(ALIAS.cui[w]); return; }
      if (ALIAS.meal[w] && out.meal.indexOf(ALIAS.meal[w]) < 0) { out.meal.push(ALIAS.meal[w]); return; }
      rest.push(w);
    });
    out.text = rest.join(' ');
    return out;
  }

  function stem(w) { return w.length > 4 ? w.replace(/(ies)$/, 'y').replace(/(oes|ses|xes|ches|shes)$/, function (x) { return x.slice(0, -2); }).replace(/([^s])s$/, '$1') : w; }
  function alts(w) { var a = [w], st = stem(w); if (st !== w) a.push(st); (SYN[w] || SYN[st] || []).forEach(function (x) { a.push(x); }); return a; }
  function hit(list, alt) {
    for (var i = 0; i < list.length; i++) { var v = list[i]; if (v === alt || (alt.length >= 3 && v.indexOf(alt) === 0)) return true; }
    return false;
  }
  function phraseHit(list, phrase) { return (' ' + list.join(' ') + ' ').indexOf(' ' + phrase) > -1; }
  /* every word must match somewhere; title counts most */
  function score(r, toks) {
    var total = 0;
    for (var i = 0; i < toks.length; i++) {
      var as = alts(toks[i]), best = 0;
      for (var j = 0; j < as.length; j++) {
        var a = as[j], multi = a.indexOf(' ') > -1;
        var f = multi ? phraseHit : hit;
        if (f(r._t, a)) best = Math.max(best, 10);
        else if (f(r._g, a)) best = Math.max(best, 7);
        else if (f(r._x, a)) best = Math.max(best, 5);
        else if (f(r._n, a)) best = Math.max(best, 3);
        else if (r._b.length && f(r._b, a)) best = Math.max(best, 1);
      }
      if (!best) return 0;
      total += best;
    }
    if (toks.length > 1 && phraseHit(r._t, toks.join(' '))) total += 8;
    return total;
  }
  function tokens(text) { return words(text).filter(function (w) { return !STOP[w] && (w.length > 1 || /\d/.test(w)); }); }

  /* typo help: a word with no match becomes the closest real word in the library */
  var VOCAB = null;
  function vocab(list) {
    if (VOCAB) return VOCAB;
    var c = {};
    list.forEach(function (r) { [r._t, r._g, r._n, r._x].forEach(function (ws) { ws.forEach(function (w) { if (w.length > 2 && !/\d/.test(w)) c[w] = (c[w] || 0) + 1; }); }); });
    VOCAB = c; return c;
  }
  function dist(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i]; var rowMin = i;
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) cur[j] = Math.min(cur[j], prev[j - 2] + 1);
        if (cur[j] < rowMin) rowMin = cur[j];
      }
      if (rowMin > max) return max + 1;
      prev = cur;
    }
    return prev[b.length];
  }
  function correct(word, list) {
    if (word.length < 4) return null;
    var v = vocab(list), max = word.length <= 6 ? 1 : 2, best = null, bd = 9, bc = 0;
    for (var w in v) {
      if (w[0] !== word[0] && max < 2) continue;
      var d = dist(word, w, max);
      if (d <= max && (d < bd || (d === bd && v[w] > bc))) { best = w; bd = d; bc = v[w]; }
    }
    return best;
  }
  function search(list, text) {
    var toks = tokens(text), fixed = [];
    if (!toks.length) return { list: list.slice(), toks: toks, fixed: fixed, scores: null };
    toks = toks.map(function (t) {
      var any = list.some(function (r) { return score(r, [t]) > 0; });
      if (any) return t;
      var c = correct(t, list); if (c) { fixed.push([t, c]); return c; }
      return t;
    });
    var scores = {}, out = [];
    list.forEach(function (r) { var s = score(r, toks); if (s) { scores[r.h] = s; out.push(r); } });
    out.sort(function (a, b) { return scores[b.h] - scores[a.h]; });
    return { list: out, toks: toks, fixed: fixed, scores: scores };
  }

  /* ---------------- saved recipes (this browser only) ---------------- */
  var saved = {
    all: function () { return store('irh-saved') || []; },
    has: function (h) { return saved.all().indexOf(h) > -1; },
    toggle: function (h) {
      var a = saved.all(), i = a.indexOf(h);
      if (i > -1) a.splice(i, 1); else a.unshift(h);
      store('irh-saved', a.slice(0, 300));
      document.dispatchEvent(new CustomEvent('irh:saved', { detail: { h: h, on: i < 0 } }));
      return i < 0;
    }
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-irh-save]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var on = saved.toggle(b.getAttribute('data-irh-save'));
    document.querySelectorAll('[data-irh-save="' + b.getAttribute('data-irh-save') + '"]').forEach(function (x) {
      x.setAttribute('aria-pressed', on ? 'true' : 'false');
      x.setAttribute('aria-label', on ? 'Remove from saved recipes' : 'Save recipe');
    });
  });

  /* ---------------- a recipe card ---------------- */
  function kicker(r) {
    var a = [];
    if (r.cui[0]) a.push(labelOf('cui', r.cui[0]));
    if (r.meal[0]) a.push(labelOf('meal', r.meal.filter(function (k) { return k !== 'mains'; })[0] || r.meal[0]));
    else if (r.main[0]) a.push(labelOf('main', r.main[0]));
    return a.join(' · ');
  }
  function card(r, extra) {
    var on = saved.has(r.h), img = r.i, jar = false;
    if (!img && r.x[0] && r.x[0].i) { img = r.x[0].i; jar = true; }
    var meta = [];
    if (r.ing.length) meta.push(r.ing.length + ' ingredients');
    if (r.serv && /^\d+$/.test(r.serv)) meta.push('Serves ' + r.serv);
    if (r.kcal) meta.push(r.kcal + ' kcal');
    var spices = r.x.filter(function (p) { return p.i; }).slice(0, 3);
    return '<article class="irh-card">' +
      '<a class="irh-card__a" href="' + esc(r.u) + '">' +
        '<div class="irh-card__media' + (jar ? ' is-jar' : '') + '">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async" width="640" height="480">' : '') +
          (r.total != null ? '<span class="irh-time' + (r.total <= 30 ? ' is-fast' : '') + '">' + icon(r.total <= 30 ? 'bolt' : 'clock') + fmt(r.total) + '</span>' : '') +
        '</div>' +
        '<div class="irh-card__body">' +
          (kicker(r) ? '<span class="irh-card__kick">' + esc(kicker(r)) + '</span>' : '') +
          '<h3>' + esc(r.t) + '</h3>' +
          (extra || '') +
          (meta.length ? '<div class="irh-card__meta">' + meta.map(function (m) { return '<span>' + esc(m) + '</span>'; }).join('') + '</div>' : '') +
          (spices.length ? '<div class="irh-card__spices"><span>' + spices.map(function (p) { return '<img src="' + esc(p.i) + '" alt="' + esc(shortTitle(p.t)) + '" title="' + esc(shortTitle(p.t)) + '" loading="lazy" width="26" height="26">'; }).join('') + '</span>Made with iSpice</div>' : '') +
        '</div>' +
      '</a>' +
      '<button class="irh-save" type="button" data-irh-save="' + esc(r.h) + '" aria-pressed="' + on + '" aria-label="' + (on ? 'Remove from saved recipes' : 'Save recipe') + '">' + icon('heart') + '</button>' +
    '</article>';
  }

  window.IRH = {
    esc: esc, norm: norm, words: words, icon: icon, store: store, mins: mins, fmt: fmt, load: load, prep: prep,
    MEAL: MEAL, CUI: CUI, MAIN: MAIN, LIFE: LIFE, TIME: TIME, REGIONS: REGIONS, labelOf: labelOf,
    understand: understand, search: search, tokens: tokens, stem: stem, cleanName: cleanName, isHeader: isHeader,
    STAPLE: STAPLE, SPICE_LINE: SPICE_LINE, shortName: shortName, shortTitle: shortTitle,
    saved: saved, card: card, kicker: kicker, linesFromBody: linesFromBody
  };
})();
